import Vue from 'vue'
import axios from 'axios'

export const healthConsentBus = new Vue()

// * localStorage flag per patient, so the HIPAA consent modal shows once for
// * each patient who signs in on this device, as newself-front does
const HIPAA_STORAGE_KEY = 'rxpros-hipaa-accepted'

function consentKey(userId) {
  return userId ? `${HIPAA_STORAGE_KEY}_${userId}` : HIPAA_STORAGE_KEY
}

function hasAcceptedHipaa(userId) {
  try {
    return localStorage.getItem(consentKey(userId)) === '1'
  } catch (e) {
    return false
  }
}

function markHipaaAccepted(userId) {
  try {
    localStorage.setItem(consentKey(userId), '1')
  } catch (e) {
    // NOTE: storage may be unavailable (private mode, quota) - fall through silently
  }
}

let pendingResolver = null
let pendingUserId = null

export function requestHealthConsent(userId) {
  // * Skip the modal entirely if this patient has already agreed on this device
  if (hasAcceptedHipaa(userId)) {
    return Promise.resolve(true)
  }

  if (pendingResolver) {
    pendingResolver(false)
    pendingResolver = null
  }

  return new Promise((resolve) => {
    pendingResolver = resolve
    pendingUserId = userId || null
    healthConsentBus.$emit('hic-open')
  })
}

export function resolveHealthConsent(accepted) {
  const userId = pendingUserId
  pendingUserId = null
  if (pendingResolver) {
    const resolver = pendingResolver
    pendingResolver = null
    resolver(!!accepted)
  }
  healthConsentBus.$emit('hic-close')

  if (accepted) {
    markHipaaAccepted(userId)
    const apiBase = process.env.VUE_APP_API_ENDPOINT
    if (apiBase) {
      axios.get(`${apiBase}/api/accept-hippa`).catch(() => {})
    }
  }
}
